const iconStyle = "w-8 h-8";

export function CricketBallIcon({ className = iconStyle }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" stroke="#F26522" strokeWidth="2">
      <circle cx="20" cy="20" r="14" />
      <path d="M12 12c4 3 8 3 12 0" strokeLinecap="round" />
      <path d="M16 28c3-4 3-8 0-12" strokeLinecap="round" />
    </svg>
  );
}

export function BaseballIcon({ className = iconStyle }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" stroke="#F26522" strokeWidth="2">
      <circle cx="20" cy="20" r="14" />
      <path d="M11 14c2 2 2 5 0 7M11 21c2 2 2 5 0 7" strokeLinecap="round" />
      <path d="M29 14c-2 2-2 5 0 7M29 21c-2 2-2 5 0 7" strokeLinecap="round" />
    </svg>
  );
}

export function SoftballIcon({ className = iconStyle }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" stroke="#F26522" strokeWidth="2">
      <circle cx="20" cy="20" r="14" />
      <path d="M10 16c3 1 5 3 6 6" strokeLinecap="round" />
      <path d="M24 10c1 3 3 5 6 6" strokeLinecap="round" />
      <path d="M30 24c-3-1-5-3-6-6" strokeLinecap="round" />
      <path d="M16 30c-1-3-3-5-6-6" strokeLinecap="round" />
    </svg>
  );
}

export function SoccerBallIcon({ className = iconStyle }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" stroke="#F26522" strokeWidth="1.8">
      <circle cx="20" cy="20" r="14" />
      <path d="M20 6v5M20 29v5" />
      <path d="M8 14l4 3M28 23l4 3" />
      <path d="M8 26l4-3M28 17l4-3" />
      <polygon points="20,11 24,14 23,19 17,19 16,14" strokeWidth="1.8" />
      <line x1="17" y1="19" x2="14" y2="23" />
      <line x1="23" y1="19" x2="26" y2="23" />
      <line x1="16" y1="14" x2="12" y2="14" />
      <line x1="24" y1="14" x2="28" y2="14" />
      <line x1="20" y1="11" x2="20" y2="6" />
    </svg>
  );
}

export function PickleballIcon({ className = iconStyle }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" stroke="#F26522" strokeWidth="2">
      <circle cx="20" cy="20" r="14" />
      <path d="M14 8c0 6-2 10 6 12" strokeLinecap="round" />
      <path d="M26 32c0-6 2-10-6-12" strokeLinecap="round" />
      <circle cx="16" cy="17" r="1.5" fill="#F26522" stroke="none" />
      <circle cx="24" cy="23" r="1.5" fill="#F26522" stroke="none" />
      <circle cx="20" cy="14" r="1.5" fill="#F26522" stroke="none" />
      <circle cx="20" cy="26" r="1.5" fill="#F26522" stroke="none" />
    </svg>
  );
}

export function BoxCricketIcon({ className = iconStyle }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" stroke="#F26522" strokeWidth="2">
      <path d="M14 12l6-4 6 4v10l-6 4-6-4z" />
      <path d="M14 12l6 4 6-4" />
      <path d="M20 16v10" />
      <path d="M14 22l6 4 6-4" />
    </svg>
  );
}
